import Dropdown from './Dropdown';

import withContainer from '../hoc/withContainer';

export default withContainer(Dropdown);
